import React, {useEffect, useState} from "react";
import styled from "styled-components";
import assetHistory from "../../../assets/imgs/asset_history.svg"
import usdtImg from "../../../assets/imgs/logo.png"
import ethImg from '../../../assets/imgs/eth.png'
import {NullStyle} from "../../claims/list/main_list_widget";
import {HttpStatus, useWait} from "../../../utils/wait_fn";
import {HttpServer} from "../../../net/http_server";
import {AssetObject, AssetList} from "../../../interface/personal/card";
import {getBalanceNumber} from "../../../utils/formatBalance";
import {DateUtils} from "../../../utils/date";
import {PageInatWidegt} from "../../../widget/pub/paginat_widget";
import {CircularProgress} from "@material-ui/core";

const ImgMap:any = {
    'nsure':usdtImg,
    'eth':ethImg
}
export const BottomWapWidget: React.FC = () => {
    const {request, data,status} = useWait<AssetObject>(HttpServer.asset);
    const [page,setPage] = useState(1);
    useEffect(() => {
        request(page)
    }, [page])
    return (
        <WapStyle>
            <h2 className={'title'}>
                <img src={assetHistory} alt=""/>
                Assessment history
            </h2>
            <div className={'bar padding'}>
                <div>Asset</div>
                <div>Amount</div>
                <div>Date</div>
                {/*<div>Transaction</div>*/}
                <div>Action</div>
            </div>

            {status === HttpStatus.wait ? <CircularProgress/>
                :
                <div className={'main'}>
                {
                    !data?.total ? <NullStyle>N/A</NullStyle> :
                        data.asset_list.map((ev, i) => <CellWidget model={ev} key={i + "dasd"}/>)
                }
            </div>}
            <PageInatWidegt setPage={setPage} total={data?.total}/>
        </WapStyle>
    );
}


const CellWidget: React.FC<{ model: AssetList }> = ({model}) => {
    return (
        <div className={'padding cell'}>
            <div><img src={ImgMap[(model.asset.toLowerCase())]} alt=""/> {model.asset}</div>
            <div>{getBalanceNumber(model.amount)}</div>
            <div>{DateUtils.dataString(model.date)}</div>
            {/*<div>{UrlHaxFormat('0xfff', 'tx')}</div>*/}
            <div>{model.action}</div>
        </div>
    );
}


const WapStyle = styled.div`
  margin-top: 40px;
  box-sizing: border-box;
  margin-bottom: 50px;
  background-color: #FFFFFF;
  border-radius: 5px;

  .bar {
    background-color: #F9FAFF;
    height: 50px;
    box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.06);
  }

  .padding {
    display: flex;
    justify-content: center;
    padding: 0 40px;
    box-sizing: border-box;
    align-items: center;

    div {
      flex: 2;
    }

    div:nth-child(1) {
      text-align: left;
    }

    div:nth-child(2) {
      flex: 1;

    }

    div:nth-child(3) {
      flex: 3;
    }

    div {
      text-align: right;
    }
  }

  .cell {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #D5D5D5;

    div {
      font-size: 16px;
      font-weight: 400;
      color: #666666;
    }

    div:nth-child(1) {
      align-items: center;
      display: flex;

      img {
        display: block;
        width: 25px;
        margin-right: 5px;
      }
    }
  }

  .cell:last-child {
    border-bottom: none;
  }

  .title {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: #222222;
    padding: 15px 0;
    line-height: 1;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      display: block;
      margin-right: 20px;
    }
  }
`
